module.exports = __webpack_public_path__ + "static/img/banner15.9a79ed15.png";